export default __webpack_public_path__ + "static/media/warmmetabolismdrink-wide@3x.2f937142.jpg";